import { config } from '@fortawesome/fontawesome-svg-core';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-nice-select/css/nice-select.css';

import './static/assets/css/flaticon.min.css';
import './static/assets/css/style.css';
import './static/assets/css/globals.css';

import '@fortawesome/fontawesome-svg-core/styles.css';

config.autoAddCss = false;

// Google Analytics - śledzenie nawigacji po stronie
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-0HREP8E7NR', {
      page_path: location.pathname + location.search,
    });
  }
};
